import { render, staticRenderFns } from "./_login.vue?vue&type=template&id=523c0456&scoped=true"
import script from "./_login.vue?vue&type=script&lang=js"
export * from "./_login.vue?vue&type=script&lang=js"
import style0 from "./_login.vue?vue&type=style&index=0&id=523c0456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523c0456",
  null
  
)

export default component.exports